// source: https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/
// this solution is from 2019, i hope we can figure something better soon
// @todo remove the file when ABSOLUTELY convinced it is no longer needed
import { isMobile } from './isMobile';

const { body } = document;

const bodyModalOpen = 'body--modal-open';
let scrollPosition = 0;

const fixStickyElements = () => {
  // @todo this is now working only on Product finder filters
  // i tried with other cases but apparently they don't work
  // so we need to investigate there also and make the solution universal as possible
  // or, you know, stop using this and find a better solution altogether
  const stickyElements = document.querySelectorAll('.sticky');
  stickyElements.forEach((el) => {
    const boundingRect = el.getBoundingClientRect();
    const containerRect = el.parentNode.getBoundingClientRect();

    if (boundingRect.top <= 0 || boundingRect.bottom >= containerRect.bottom) {
      el.style.setProperty(
        '--sticky-scroll-top',
        `${scrollPosition + boundingRect.top}px`,
      );
      el.style.position = 'absolute';
    }
  });
};

const resetStickyElements = () => {
  const stickyElements = document.querySelectorAll('.sticky');
  stickyElements.forEach((el) => {
    el.style.removeProperty('position');
    el.style.setProperty('--sticky-scroll-top', '');
  });
};

export default {
  lock() {
    scrollPosition = window.scrollY;

    if (!isMobile()) {
      fixStickyElements();
    }

    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollPosition}px`;
    body.style.width = '100%';
    // keeps track of where the sticky elements should stay when
    // page is unscrollable
    body.style.setProperty('--scroll-position-top', `${scrollPosition}px`);

    if (scrollPosition > 0) {
      body.classList.add(bodyModalOpen);
    }
  },
  unlock() {
    resetStickyElements();

    ['overflow', 'position', 'top', 'width', '--scroll-position-top'].forEach(
      (prop) => body.style.removeProperty(prop),
    );

    window.scrollTo(0, scrollPosition);

    body.classList.remove(bodyModalOpen);
  },
};
